import { getActiveZones } from "./index23.js";
import { RG_TYPE } from "@project-rouge/rg-core";
import { getRgObjectsOfType as getRgObjectsOfType$1 } from "@project-rouge/rg-three";
const getActiveBuildings = (parent, aggProps) => {
	return getActiveZones(parent, aggProps).flatMap((zone) => getRgObjectsOfType$1(zone, RG_TYPE.Building));
};
export { getActiveBuildings };

//# sourceMappingURL=index24.js.map